<template>
  <div class="glass-masters-block">
    <div class="title">{{ $t('Meet the glass masters') }}</div>
    <div class="glass-masters">
      <div v-for="item in glassMastersData" class="glass-masters__item">
        <span class="glass-masters__item__name"> {{ item.name }}</span>
        <span class="glass-masters__item__role"> {{ $t(item.role) }}</span>
        <nuxt-img :src="item.image" format="webp" loading="lazy" />
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent, ref } from '@nuxtjs/composition-api';

export default defineComponent({
  name: 'MeetTheGlassMasters',
  components: {},
  setup() {
    const masterGlassmaker = 'Master Glassmaker';
    const glassMastersData = ref([
      {
        name: 'Basilio',
        // eslint-disable-next-line sonarjs/no-duplicate-string
        role: masterGlassmaker,
        image: '/editorial/about/glassMasters/basilio.jpg',
      },
      {
        name: 'Andrea',
        role: masterGlassmaker,
        image: '/editorial/about/glassMasters/andrea.jpg',
      },
      {
        name: 'Daniele',
        role: masterGlassmaker,
        image: '/editorial/about/glassMasters/daniele.jpg',
      },
      {
        name: 'Marco',
        role: masterGlassmaker,
        image: '/editorial/about/glassMasters/marco.jpg',
      },
      {
        name: 'Ottorino',
        role: masterGlassmaker,
        image: '/editorial/about/glassMasters/ottorino.jpg',
      },
      {
        name: 'Roberto',
        role: masterGlassmaker,
        image: '/editorial/about/glassMasters/roberto.jpg',
      },
    ]);
    return {
      glassMastersData,
    };
  },
});
</script>

<style lang="scss">
.glass-masters-block {
  margin-top: 2.5rem;
  margin-bottom: 5rem;
  @include for-desktop {
    padding-top: 5rem;
    padding-left: 1.25rem;
    padding-right: 1.25rem;
    padding-bottom: 8.125rem;
  }
  .title {
    @include mobile-h4;
    padding-bottom: 1.875rem;
    margin-left: 1.25rem;
    margin-right: 1.5625rem;
    @include for-desktop {
      @include desktop-h4;
      padding-bottom: 2.5rem;
      max-width: 30.9375rem;
    }
  }
  .glass-masters {
    display: flex;
    flex-direction: column;
    @include for-desktop {
      display: grid;
      grid-template-columns: 33% 33% 34%;
      border-left: 1px solid black;
      border-right: 1px solid black;
    }
    &__item {
      display: flex;
      flex-direction: column;
      @include for-desktop {
        border-top: 1px solid black;
      }
      border-bottom: 1px solid black;
      padding: 1.25rem;
      &__name {
        @include mobile-h6;
        @include for-desktop {
          @include desktop-h6;
        }
      }
      &__role {
        @include mobile-h6;
        padding-bottom: 1.25rem;
        @include for-desktop {
          @include desktop-h6;
          padding-bottom: 0.625rem;
        }
      }
      @include for-desktop {
        &:nth-child(3n + 2) {
          border-right: 1px solid black;
          border-left: 1px solid black;
        }
      }
      @include for-mobile {
        &:first-child {
          border-top: 1px solid black;
        }
      }
    }
  }
}
</style>
